import { observable } from 'mobx';

export type WorkflowType = 'default' | 'overseas'; // デフォルト or 海外出張

export type WorkflowResponseArgs = {
  id: number;
  workflow_type: WorkflowType;
};

export type WorkflowArgs = {
  id: number;
  workflowType: WorkflowType;
};

export const convertWorkflowResponseToArgs = (response: WorkflowResponseArgs): WorkflowArgs => {
  return {
    id: response.id,
    workflowType: response.workflow_type
  };
};

export default class Workflow {
  @observable
  readonly id: number;

  @observable
  workflowType: string;

  constructor(args: WorkflowArgs) {
    this.id = args.id;
    this.workflowType = args.workflowType;
  }
}
